<script setup>
import { useBg } from '@/stores/bgStore';
import { useIntersectionObserver } from '@vueuse/core';
import ImgMedia from '../Images/ImgMedia.vue';
import { ref } from 'vue';
const bg = useBg();
const target = ref(null);
useIntersectionObserver(target, ([{ isIntersecting }], observerElement) => {
    isIntersecting ? bg.add('content-image') : bg.remove('content-image');
});

const props = defineProps({
    title: String,
    text: String,
    image: Object,
    flip_order: Boolean,
});
</script>

<template>
    <div ref="target" class="container my-16 md:my-30">
        <div class="grid gap-12 xl:grid-cols-2">
            <div class="xl:order-2" :class="{ 'xl:order-1': flip_order }" v-if="image">
                <ImgMedia :media="image" :sizes="{ default: '100vw', lg: '600px' }" />
                <div class="h-2 mx-4 bg-secondary"></div>
            </div>

            <div class="xl:order-1" :class="{ 'xl:order-2': flip_order }">
                <h2 class="mb-4 text-2xl font-bold" v-if="title">{{ title }}</h2>
                <div v-html="text" class="mb-6 prose text-primary"></div>
            </div>
        </div>
    </div>
</template>
